export default function* clinicianToDosSaga() {
	// See example in containers/HomePage/saga.js
}
